export const TelegramLogo: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="white"
    {...props}
  >
    <title>Telegram Logo</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.78777 9.84194C6.15799 7.94402 9.0673 6.6829 10.5282 6.07107C14.6861 4.33547 15.5602 4.0358 16.1221 4.02332C16.2469 4.02332 16.5216 4.04829 16.7089 4.19812C16.8588 4.32299 16.8962 4.48531 16.9212 4.61017C16.9462 4.73504 16.9711 4.99725 16.9462 5.19703C16.7214 7.56943 15.7475 13.3256 15.248 15.9727C15.0358 17.0965 14.6237 17.4711 14.2241 17.5085C13.3501 17.5835 12.6883 16.9342 11.8517 16.3848C10.5282 15.5232 9.79151 14.9863 8.50541 14.1372C7.01954 13.1633 7.98099 12.6264 8.83006 11.7524C9.05481 11.5276 12.8881 8.03143 12.963 7.71927C12.9755 7.68181 12.9755 7.53197 12.8881 7.45705C12.8007 7.38214 12.6758 7.40711 12.576 7.43208C12.4386 7.45706 10.3409 8.85552 6.25788 11.615C5.65853 12.0271 5.12162 12.2268 4.63465 12.2143C4.09774 12.2019 3.07386 11.9147 2.29971 11.6649C1.36324 11.3653 0.614058 11.203 0.67649 10.6785C0.713949 10.4038 1.08854 10.1291 1.78777 9.84194Z"
    />
  </svg>
);
